export default {
    viewTree: []
};
